import { Component } from '@angular/core';

@Component({
  selector: 'app-emp-grievance-footer',
  templateUrl: './emp-grievance-footer.component.html',
  styleUrls: ['./emp-grievance-footer.component.scss']
})
export class EmpGrievanceFooterComponent {

}
